<template>
  <div class="case-image-upload">
    <div :id="uploadId" class="uploader uploader-warning"></div>
    <el-row v-if="value && value.length">
      <el-col
        :span="6"
        v-for="(item, idx) in value"
        :key="uploadId + '-' + idx + '-' + (item.filePath || '')"
        style="padding: 5px"
      >
        <el-card :body-style="{ padding: '0px' }">
          <el-image
            style="width: 100%; height: 100px"
            fit="cover"
            :src="domain + item.filePath"
            :preview-src-list="previewList"
          ></el-image>
          <div style="padding: 5px 14px 10px 14px">
            <div class="bottom clearfix">
              <el-button-group>
                <el-tooltip content="前移" placement="top">
                  <el-button
                    type="primary"
                    icon="el-icon-arrow-left"
                    size="mini"
                    :disabled="idx === 0"
                    @click="move(idx)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    @click="remove(idx)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";

export default {
  name: "CaseImageUpload",
  props: {
    value: { type: Array, default: () => [] },
    uploadId: { type: String, required: true },
    active: { type: Boolean, default: false }
  },
  data() {
    return {
      domain: url.getDomain(),
      uploaderInited: false
    };
  },
  computed: {
    previewList() {
      var _this = this;
      return (this.value || [])
        .filter(function(x) { return x.filePath; })
        .map(function(x) { return _this.domain + x.filePath; });
    }
  },
  watch: {
    active(val) {
      if (val) this.$nextTick(() => this.initUploader());
    },
    uploadId() {
      this.uploaderInited = false;
      if (this.active) this.$nextTick(() => this.initUploader());
    }
  },
  mounted() {
    if (this.active) this.$nextTick(() => this.initUploader());
  },
  methods: {
    initUploader() {
      if (this.uploaderInited) return;
      var sel = "#" + this.uploadId;
      if ($(sel + " input").length > 0) {
        this.uploaderInited = true;
        return;
      }
      var _this = this;
      $(sel).uploader({
        url: url.getUpload(),
        fileExts: "jpg;png;jpeg",
        text: "上传图片",
        more: true,
        auto: true,
        handleType: "0",
        max: 1024 * 1024 * 5,
        onSuccess: function(data) {
          var list = (_this.value || []).slice();
          list.push({ filePath: data.relativeName, fileName: "" });
          _this.$emit("input", list);
        }
      });
      this.uploaderInited = true;
    },
    move(idx) {
      if (idx <= 0) return;
      var list = this.value.slice();
      var temp = list[idx];
      list[idx] = list[idx - 1];
      list[idx - 1] = temp;
      this.$emit("input", list);
    },
    remove(idx) {
      var list = this.value.slice();
      list.splice(idx, 1);
      this.$emit("input", list);
    }
  }
};
</script>

<style scoped>
.case-image-upload {
  width: 100%;
}
</style>
